export const AUDIT_STATUS = {
  pending: 'PENDING',
  accepted: 'ACCEPTED',
  rejected: 'REJECTED'
};
export const AUDIT_ACTION = {
  accept: 'ACCEPT',
  reject: 'REJECT',
  retract: 'RETRACT'
};
export const PUBLISH_STATUS = {
  pending: 'PENDING',
  published: 'PUBLISHED',
  failed: 'FAILED'
};
export const PUBLISH_ACTION = {
  publish: 'PUBLISH',
  unpublish: 'UNPUBLISH'
};
export const IMAGEGRID_QUALIFIERS = {
  all: 'all',
  orphaned: 'orphaned',
  audit: 'audit',
  // to-audit
  approved: 'audit-approved',
  rejected: 'audit-rejected',
  publish: 'publish',
  // to-publish
  publishFailed: 'publish-failed',
  published: 'publish-published'
};
export const BASE_URIS = {
  prefix: '/ws/',
  // tpis endpoints
  listPrograms: 'api/list/programs',
  listOrphans: 'api/list/orphans',
  listImages: 'api/list/images',
  listAssociations: 'api/list/associations',
  listLegacyImages: 'api/list/legacy/images',
  listExistingImages: 'api/list/existing/images',
  audit: 'api/audit',
  publish: 'api/publish',
  uploadImages: 'api/upload/images',
  isVisible: 'api/is/visible',
  lookup: 'api/lookup',
  displayInfo: 'api/display/info',
  updateProgram: 'api/update/program',
  imageTypes: 'api/list/image/types?size=100',
  // This one is pretty much static
  filters: 'api/list/filters?size=50',
  // This one is also static (50 is the max page size for this call)
  listUsers: 'admin/list/users',
  createUser: 'admin/create/user',
  updateUser: 'admin/update/user',
  deleteUser: 'admin/delete/user',
  impersonate: 'admin/impersonate',
  // tpic internal endpoints
  token: '/sat_token',
  session: '/session_exists',
  isAdmin: 'is_admin',
  mail: '/mail',
  supportMail: '/support-mail',
  logout: '/perform_logout',
  resetCode: '/request_password_reset',
  resetPass: '/reset_password',
  stop_impersonating: '/stop_impersonating',
  docs: '/docs/index.html'
};
export const IMAGETABLE_DESCRIPTIONS = {
  all: 'all',
  legacy: 'legacy',
  published: 'published',
  publishPending: 'publish-pending',
  publishFailed: 'publish-failed',
  auditPending: 'audit-pending',
  accepted: 'accepted',
  rejected: 'rejected',
  existing: 'existing'
};
export const BULK_ACTIONS = {
  AUDIT: 'Audit',
  PUBLISH: 'Publish'
};
export const IMAGE_BUTTON_LIST_QUALIFIERS = {
  quickAudit: 'quick-audit'
};
export const DISPLAY_IMAGES = {
  new: 'new',
  legacy: 'legacy'
};
export const ROLES = {
  admin: 'admin',
  manager: 'manager',
  provider: 'provider',
  auditor: 'auditor',
  publisher: 'publisher'
};
export const LOCAL_STORAGE_ITEM_NAMES = {
  username: 'username',
  role: 'role',
  partners: 'partners',
  preferredPageSize: 'PAGESIZE',
  preferredSortField: 'SORTFIELD',
  preferredSortDesc: 'SORTDESC',
  darkMode: 'DARKMODE',
  // @cylon
  selectedPartner: 'SELECTED_PARTNER',
  capabilities: 'CAPS',
  preferredAspectRatio: 'PREFERRED_ASPECT_RATIO',
  specialSelectionRules: 'SELECTION_RULES',
  defaultSpecialSelectionRule: 'DEFAULT_SELECTION_RULE',
  defaultAspectRatio: 'DEFAULT_ASPECT_RATIO',
  myriadBaseUrl: 'MYRIAD_BASE_URL',
  partnerOwnerId: 'PARTNER_OWNER_ID',
  impersonatingUser: 'IMPERSONATING_USER',
  impersonatedUsername: 'I_USER',
  impersonatedRole: 'I_ROLE',
  impersonatedVisiblePartners: 'I_PARTNERS'
};
export const SESSION_STORAGE_ITEM_NAMES = {
  CSRFTOKEN: 'CSRFTOKEN',
  IMPERSONATION_ALLOWED: 'I_ALLOWED',
  TPIS_TOKEN: 'TOKEN'
};
export const TPIC_RESP_HEADERS = {
  username: 'x-meta-tpic-user',
  role: 'x-meta-tpic-role',
  partner: 'x-meta-tpic-partner',
  myriadBaseUrl: 'x-meta-myriad-url',
  impersonationAllowed: 'x-meta-impersonation-allowed'
};
export const ID_SPACE = {
  MERLIN: 'MERLIN',
  ADI: 'ADI'
};

/**
 * QueryString values that will be displayed to the user
 */
export const Q_STRING = {
  MERLIN_ID: 'merlinId',
  ENTITY_ID: 'entityId',
  PROVIDER: 'entityProvider',
  TITLE: 'title',
  ADI_ID: 'adiId',
  TAB: 't',
  PAGE: 'p',
  SIZE: 's',
  MESSAGE: 'message',
  EXPIRED: 'expired',
  SORT_FIELD: 'sort',
  SORT_DESCENDING: 'desc',
  RESET_CODE: 'code',
  RATIO: 'ratio',
  FILTERS: 'filters',
  RULE: 'rule'
};

/**
 * Parameter values for use in API calls
 */
export const TPIS_PARAMS = {
  PAGE: 'page',
  PAGE_SIZE: 'size',
  SORT_FIELD: 'sort.field',
  SORT_DESC: 'sort.descending',
  ENTITY_ID: 'entityId',
  IMAGE_ID: 'imageId',
  PROVIDER: 'entityProvider',
  TITLE: 'title',
  DESCRIPTION: 'description',
  TYPE: 'type',
  LOCALIZED_TITLE: 'localizedTitle',
  LOCALIZED_DESCRIPTION: 'localizedDescription',
  ACTION: 'action',
  FILTERS: 'types',
  AUDIT_PENDING: '&auditStatus=PENDING',
  AUDIT_ACCEPTED: '&auditStatus=ACCEPTED',
  AUDIT_REJECTED: '&auditStatus=REJECTED',
  PUBLISH_PENDING: '&auditStatus=ACCEPTED&publishStatus=PENDING',
  PUBLISH_FAILED: '&publishStatus=FAILED',
  PUBLISHED: '&publishStatus=PUBLISHED',
  INCLUDE_IMAGE: '&includeImage=true',
  INCLUDE_ASSOCIATIONS: '&includeAssociations=true',
  INCLUDE_ENTITY_MESSAGES: '&includeEntityMessages=true',
  IGNORE_UNRESOLVABLE_ENTITIES: '&ignoreUnresolvableEntities=true',
  DELETE_ENTITY_MESSAGE: '&entityMessageMethod=DELETE',
  USER_ID: 'userId',
  RATIO: 'ratio',
  USERNAME: 'username'
};
export const SORT_FIELD = {
  title: 'title',
  added: 'added',
  availableDate: 'availableDate',
  expirationDate: 'expirationDate'
};
export const ASPECT_RATIO = {
  THREE_BY_FOUR: "3x4",
  SIXTEEN_BY_NINE: "16x9"
};

/**
 * (height / width) * 100
 */
export const ASPECT_RATIO_TO_PADDING_TOP = {
  '3x4': '133.33%',
  '1x1': '100%',
  '16x9': '56.25%'
};
export const IMAGE_DISPLAY_MODE = {
  BY_ASSOCIATION: 'assoc',
  BY_IMAGE: 'image'
};
export const DATA_QUALITY_STATUS = {
  DELETED: 'DELETED',
  UPDATED: 'UPDATED'
};
export const VALID_PAGE_SIZES = [10, 20, 30, 40, 50];
export const COOKIE_NAMES = {
  CSRF_TOKEN: 'TOKEN'
};
export const TPIS_CAPABILITIES = {
  MANAGE: "x1:compass:merlin:tpic:manage",
  ADMIN: "x1:compass:merlin:tpic:admin",
  AUDIT: "x1:compass:merlin:tpic:audit",
  PUBLISH: "x1:compass:merlin:tpic:publish",
  READ: "x1:compass:merlin:tpic:read",
  WRITE: "x1:compass:merlin:tpic:write"
};
export const SERIES_MASTER_ROLLUP_VODPROVIDERSOURCE = {
  NONE: "NONE",
  PROPERTIES: "PROPERTIES"
};
export const ENTITY_MESSAGE_TYPES = "CanonicalOverride,CanonicalOverrideShort";